__turbopack_context__.v({
  "background": "MainGridPage-module-scss-module__6WOFaG__background",
  "blocksBackgroundColor": "MainGridPage-module-scss-module__6WOFaG__blocksBackgroundColor",
  "blocksFontColor": "MainGridPage-module-scss-module__6WOFaG__blocksFontColor",
  "breadcrumbs": "MainGridPage-module-scss-module__6WOFaG__breadcrumbs",
  "classroomFollowFloatingButton": "MainGridPage-module-scss-module__6WOFaG__classroomFollowFloatingButton",
  "classroomHeaderLabels": "MainGridPage-module-scss-module__6WOFaG__classroomHeaderLabels",
  "classroomHeaderTopBlock": "MainGridPage-module-scss-module__6WOFaG__classroomHeaderTopBlock",
  "classroomLinkedFloatingButton": "MainGridPage-module-scss-module__6WOFaG__classroomLinkedFloatingButton",
  "classroomMultipleTeachers": "MainGridPage-module-scss-module__6WOFaG__classroomMultipleTeachers",
  "classroomTeacher": "MainGridPage-module-scss-module__6WOFaG__classroomTeacher",
  "classroomTeacherImage": "MainGridPage-module-scss-module__6WOFaG__classroomTeacherImage",
  "classroomTeacherTitle": "MainGridPage-module-scss-module__6WOFaG__classroomTeacherTitle",
  "classroomTitle": "MainGridPage-module-scss-module__6WOFaG__classroomTitle",
  "container": "MainGridPage-module-scss-module__6WOFaG__container",
  "fullWidthPage": "MainGridPage-module-scss-module__6WOFaG__fullWidthPage",
  "fullWidthPageSubPage": "MainGridPage-module-scss-module__6WOFaG__fullWidthPageSubPage",
  "grid": "MainGridPage-module-scss-module__6WOFaG__grid",
  "gridGridPage": "MainGridPage-module-scss-module__6WOFaG__gridGridPage",
  "gridWithMicrosite": "MainGridPage-module-scss-module__6WOFaG__gridWithMicrosite",
  "header": "MainGridPage-module-scss-module__6WOFaG__header",
  "hiddenWhenSmall": "MainGridPage-module-scss-module__6WOFaG__hiddenWhenSmall",
  "loginWrapper": "MainGridPage-module-scss-module__6WOFaG__loginWrapper",
  "microsite": "MainGridPage-module-scss-module__6WOFaG__microsite",
  "micrositeOpen": "MainGridPage-module-scss-module__6WOFaG__micrositeOpen",
  "micrositeTerrace": "MainGridPage-module-scss-module__6WOFaG__micrositeTerrace",
  "micrositeToggleButton": "MainGridPage-module-scss-module__6WOFaG__micrositeToggleButton",
  "micrositeToggleButtonTerrace": "MainGridPage-module-scss-module__6WOFaG__micrositeToggleButtonTerrace",
  "packery": "MainGridPage-module-scss-module__6WOFaG__packery",
  "pageTop": "MainGridPage-module-scss-module__6WOFaG__pageTop",
  "restoreButton": "MainGridPage-module-scss-module__6WOFaG__restoreButton",
  "rightAlignedHeader": "MainGridPage-module-scss-module__6WOFaG__rightAlignedHeader",
  "secondaryNavBackgroundColor": "MainGridPage-module-scss-module__6WOFaG__secondaryNavBackgroundColor",
  "teachersLabel": "MainGridPage-module-scss-module__6WOFaG__teachersLabel",
  "themeBackgroundColor": "MainGridPage-module-scss-module__6WOFaG__themeBackgroundColor",
  "themeFontColor": "MainGridPage-module-scss-module__6WOFaG__themeFontColor",
});
